import { useFeatureFlags } from 'hooks/use-feature-flags'

/**
 * Returns the base URL for test suites based on the feature flag.
 * TODO: Refactor this to a non-hook function when the feature flag is removed.
 */
export function useGetTestSuitesUrls() {
  const { agentPageRedesign: isAgentPageRedesignEnabled } = useFeatureFlags()

  const baseTestSuitesUrl = isAgentPageRedesignEnabled
    ? '/configurations/test-suites'
    : '/test-suites'

  return {
    base: () => baseTestSuitesUrl,
    byIdentifier: (identifier?: string) => `${baseTestSuitesUrl}/${identifier}`,
    new: () => `${baseTestSuitesUrl}/new`,
    testSuiteFormTab: (testSuiteId: string, tab: string) =>
      `${baseTestSuitesUrl}/${testSuiteId}/${tab}`,
    view: (testSuiteId: string) => `${baseTestSuitesUrl}/${testSuiteId}/teams`
  }
}
